/* Start upcoming content images before a fast scroll reaches them.
   Native lazy loading remains the no-JS fallback. Gallery hydration stays separate. */
(() => {
  if (window.nrImageLoadingReady) return;
  window.nrImageLoadingReady = true;
  if (!('IntersectionObserver' in window)) return;
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const img = entry.target;
      // Hidden drawers, menus, filtered cards and inactive gallery slides must not compete.
      if (!img.getClientRects().length || img.closest('[hidden], [aria-hidden="true"], .nr-gallery-slide')) continue;
      // Judge.me uses data-src instead of native loading on its review thumbnails.
      if (img.matches('.jdgm-rev__pic-img[data-src]') && img.getAttribute('src') !== img.dataset.src) img.src = img.dataset.src;
      img.loading = 'eager';
      img.decoding = 'async';
      observer.unobserve(img);
    }
  }, {rootMargin: '2400px 0px', threshold: 0});
  function register(root) {
    root.querySelectorAll('main img[loading="lazy"], .nr-design img[loading="lazy"], main .jdgm-rev__pic-img[data-src]').forEach(img => {
      if (seen.has(img) || (img.hasAttribute('data-src') && !img.matches('.jdgm-rev__pic-img')) || img.closest('cart-drawer, .nr-gallery-slide, .nr-menu-card, #product-menu')) return;
      seen.add(img);
      observer.observe(img);
    });
  }
  register(document);
  document.addEventListener('shopify:section:load', event => register(event.target));
  // Product lens/model navigation replaces the main content without a document reload.
  const main = document.querySelector('main');
  if (main) new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length)) register(document);
  }).observe(main, {childList: true, subtree: true});
})();
